/**
 * Loads the set of regional content-server URLs from the main content-server
 * The content-server now owns the Fusion Component Distribution Registry (FCDR) fetch and,
 * behind a per-user feature flag, may relay the test region registry instead of production.
 * The browser no longer talks to FCDR directly, it asks the content-server, which returns an already-parsed region maps
 */

const RegionRegistryClient = require("../cio-config/regionRegistryClient.js");
const ApplicationContext = require("../config/ApplicationContext.js");

function loadFromContentServer() {
    return RegionRegistryClient.loadRegionMap(ApplicationContext.usContentUrl());
}

module.exports = { loadFromContentServer };
